export default "__VITE_ASSET__CpJaiCG1__"